import clsx from 'clsx';

const fallbackAction = (index) => index;
export const fallbackFn = () => {
    // This is intentional
};

/**
 * @param {Number} len
 * @param {Function} action
 * @return {Array} Retorna un array.
 * */
export const createData = (len = 1, action = fallbackAction) => Array(len).fill(null).map((_, i) => action(i));

/**
 * @param {String} searchString
 * @return {Object} paramsObject
 * @example
 * // 1. Puedes usarlo enviando:
 * getSearchParams(window.location.search) // retorna {param1: '',...}
 *
 * // 2. ó puedes usarlo enviando con react-router-dom:
 *  const {search} = useLocation();
 *  getSearchParams(search) // retorna {param1: '',...}
 * */
export const getSearchParams = (searchString = '') => Object.fromEntries(new URLSearchParams(searchString).entries());

/**
 * Recibe un objeto y retorna un Url Search Params
 * @param {Object} xs
 * @return Url Search Params */
export const createUrlSearchParams = (xs) => {
    return Object.entries(xs).reduce((acc, current, currentIndex) => {
        const prefix = currentIndex === 0 ? '?' : '&';
        const [key, value] = current;

        return `${acc}${prefix}${key}=${value}`;
    }, '');
};

/**
 * @param {String} url
 * @return {Function} Función que recibe un objeto y devuelve un query string */
export const createURL = (url) => (params = {}) => `${url}${createUrlSearchParams(params)}`;

export const parsePercent = (value, withSignal) => `${(value * 100).toFixed(0)}${clsx(withSignal && '%')}`;

export const packPayload = (propsList, data) => {
    return propsList.reduce((acc, current) => {
        return {...acc, [current]: data[current]};
    }, {});
};

export const setPageTitle = (title = '') => {
    window.document.title = `${title} - Power Rimac`;
};

export const getRandomArbitrary = (min, max) => Math.round(Math.random() * (max - min) + min);

export const packPayloadForCierre = (data) => {
    const {indicadoresCualitativos, indicadoresOperativos, indicadoresExplicativos} = data;

    const propsList = [
        'resultado',
        'comentario',
        'idAsignado',
        'nombreAsignado'
    ];

    const payload = packPayload(propsList, data);

    return {
        ...payload,
        resultadosIndicadores: {
            cuantitativos: [...indicadoresExplicativos, ...indicadoresOperativos],
            cualitativos: [...indicadoresCualitativos]
        }
    };
};
